/**
 * bedesSlug — the readable BEDES id slug function.
 *
 * MUST stay in sync with the SQL twin `public.bedes_slugify(text)`
 * (supabase/migrations/20260702113400_bedes_rpcs.sql). After changing either,
 * run `npx tsx scripts/bedes/verify-slug-parity.ts` — it executes the shared
 * fixture (slug.parity-cases.ts) through BOTH implementations against a live
 * database. Both implement:
 *   lowercase
 *   → symbol spelling: $→usd, /→per, ·→-, ° and mojibake ¡→deg, &→-
 *   → accents stripped via an explicit character table (NOT Unicode NFD, so
 *     the two implementations agree on every input)
 *   → non-[a-z0-9] runs → '-'
 *   → collapse + trim '-'
 *
 * Examples (real source BEDES data):
 *   'gross floor area'   → 'gross-floor-area'
 *   '$/MWh'              → 'usd-per-mwh'
 *   'btu/hr·ft2·°f'      → 'btu-per-hr-ft2-deg-f'
 *   '(r-value)/in'       → 'r-value-per-in'
 *   '__VALUE__'          → 'value'
 */
const ACCENTS = "àáâãäåèéêëìíîïòóôõöùúûüçñ";
const PLAIN = "aaaaaaeeeeiiiiooooouuuucn";
const ACCENT_MAP = {};
for (let i = 0; i < ACCENTS.length; i++) {
    ACCENT_MAP[ACCENTS[i]] = PLAIN[i];
}
export function bedesSlug(name) {
    if (!name)
        return "";
    return name
        .toLowerCase()
        .replaceAll("$", "-usd-")
        .replaceAll("/", "-per-")
        .replaceAll("·", "-")
        .replaceAll("°", "-deg-")
        .replaceAll("¡", "-deg-")
        .replaceAll("&", "-")
        .replace(/[àáâãäåèéêëìíîïòóôõöùúûüçñ]/g, (ch) => ACCENT_MAP[ch] ?? ch)
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}
/**
 * Compound BEDES id from already-slugged segments, colon-separated. Segments
 * must be ids/slugs (call bedesSlug on raw names first); empty ones are dropped.
 *   bedesCompoundId('espm', bedesSlug('Property Name')) → 'espm:property-name'
 */
export function bedesCompoundId(...segments) {
    return segments.filter((s) => !!s && s !== "").join(":");
}
//# sourceMappingURL=slug.js.map